import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import type { RootState } from "@Reducers/index";
import { showToastNotification } from "@Reducers/toastSlice";
import { TOAST_TYPE_ERROR } from "@Services/constants";
import { useTranslation } from "@i18n";

export type IssueAction = "create" | "edit";

export function useRotatedPdfIssueGuard(): (action: IssueAction) => boolean {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isRotatedPdfPageInView = useSelector((state: RootState) => state.viewerState.isRotatedPdfPageInView);

  return useCallback(
    (action: IssueAction): boolean => {
      if (!isRotatedPdfPageInView) return false;
      dispatch(
        showToastNotification({
          content:
            action === "edit"
              ? t("You cannot edit Issues on a rotated PDF")
              : t("You cannot create Issues on a rotated PDF"),
          type: TOAST_TYPE_ERROR,
        }),
      );
      return true;
    },
    [isRotatedPdfPageInView, dispatch, t],
  );
}
